import { Button } from "@/components/ui/button";
import { HeartPulse } from "lucide-react";
import { authClient } from "@/lib/auth-client";

export function SentryTestButton(): React.ReactElement {
  return (
    <Button
      variant="outline"
      className="w-full"
      onClick={async () => {
        try {
          // On déclenche volontairement une erreur 5XX côté backend
          // en appelant une route d'auth avec un flag de test.
          await authClient.signOut({
            fetchOptions: {
              headers: {
                // Ce header est intercepté côté backend (hook better-auth)
                // pour forcer une 500 sur /sign-out uniquement en dev.
                "X-Sentry-Test": "1",
              },
            },
          });

          // Si pour une raison quelconque la route ne renvoie pas d'erreur,
          // on force quand même une erreur côté frontend.
          throw new Error("FE - Sentry test: signOut n'a pas échoué comme prévu");
        } catch (e) {
          // On encapsule l'erreur d'origine dans le throw pour que
          // Sentry (via l'ErrorBoundary) puisse tout corréler proprement.
          throw new Error("FE - Sentry test: erreur frontend après 5XX backend", {
            cause: e instanceof Error ? e : undefined,
          });
        }
      }}
    >
      <HeartPulse className="mr-2 h-5 w-5" />
      Tester Sentry
    </Button>
  );
}
